// extracted by mini-css-extract-plugin
export default {"slipBody":"betSlipComponent_slipBody__8gAIY","slipFooter":"betSlipComponent_slipFooter__jU+WV"};